import ymaps from 'ymaps';

const mapMarkerMobile = require('../img/map-marker.png');
const mapMarkerDesktop = require('../img/map-marker-desktop.png');

ymaps.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU').then(maps => {

    const address = document.getElementById('map-address').textContent;
    const myGeocoder = maps.geocode(address);
    myGeocoder.then(
      (res) => {
        const coords = res.geoObjects.get(0).geometry.getCoordinates();
        // console.log('Coordisnates:', coords);

        const map = new maps.Map('map', {
          center: coords,
          zoom: 16,
          controls: []
        });

        map.behaviors.disable([
          'drag',
          'rightMouseButtonMagnifier',
          'scrollZoom',
          'dblClickZoom',
          'leftMouseButtonMagnifier',
          'ruler',
          'routeEditor',
          'multiTouch'
        ]);

        const onMapResize = () => {
          const mapWidth = map.container.getSize()[0];

          let markerConfig = {
            iconLayout: 'default#image'
          };
          // console.log("mapWidth", mapWidth);

          if (mapWidth > 1262) {
            map.setCenter([coords[0], coords[1] + 0.005]); // change map center position
            markerConfig.iconImageHref = mapMarkerDesktop;
            markerConfig.iconImageSize = [73, 93];
            markerConfig.iconImageOffset = [-37, -102];
          } else if (mapWidth <= 1262) {
            map.setCenter(coords); // change map center position
            markerConfig.iconImageHref = mapMarkerMobile;
            markerConfig.iconImageSize = [148, 189];
            markerConfig.iconImageOffset = [-80, -200];
          }

          map.geoObjects.removeAll();
          map.geoObjects.add(new maps.Placemark(coords, {}, markerConfig));
        };

        map.container.events.add('sizechange', onMapResize);

        onMapResize();
      },
      (err) => {
        console.log(err);
      }
    );

  })
  .catch(error => console.log('Failed to load Yandex Maps', error));


// WEBPACK FOOTER //
// ./src/js/map.js